import { Modal } from "Components/modal";

export const getNotification = (selector = ".notification") =>
  Modal.getInstance(document.querySelector(selector));
export const notification = getNotification(".notification");
